import { IsotypeLogo } from "./IsotypeLogo";

// Postulados marquee — infinite horizontal ticker of Malinois' key beliefs.
// The isotype mark loops with the message. Pauses on hover.
// tone="accent" (default) — terracotta ribbon, cream type, one-ink
//   reduction of the mark (flat, clean against a solid bright color).
// tone="ink" — black ribbon, cream type, full 7-color manual palette (the
//   mark reads at its most detailed against a dark neutral, so it earns
//   showing every facet instead of the single-color reduction).
// tone="paper" — white ribbon, terracotta type, the mark's default
//   two-color signature (built for light surfaces).
//
// Runs on every viewport, including mobile/tablet — it's a plain CSS
// `transform: translateX` loop (see .animate-marquee in index.css), no
// blur/filter/JS-per-frame cost, so there's no perf reason to gate it with
// useIsMobile the way the blur-heavy background effects were.
const TONE_STYLES = {
  accent: { bg: "bg-accent", text: "text-paper", oneColor: true, invert: false },
  ink: { bg: "bg-ink", text: "text-paper", oneColor: false, invert: true },
  paper: { bg: "bg-paper", text: "text-accent", oneColor: false, invert: false },
};

export function PostuladosMarquee({ phrases = [], tone = "accent" }) {
  const { bg, text, oneColor, invert } = TONE_STYLES[tone] || TONE_STYLES.accent;

  return (
    <div
      className={`overflow-hidden ${bg} py-6 md:py-8 group`}
      data-testid="postulados-marquee"
    >
      <div className="flex whitespace-nowrap animate-marquee group-hover:[animation-play-state:paused]">
        {[0, 1].map((loop) => (
          <div
            key={loop}
            className="flex items-center pr-12"
            aria-hidden={loop === 1}
          >
            {phrases.map((phrase, i) => (
              <span key={i} className="flex items-center">
                <span className={`font-heading italic ${text} text-xl md:text-2xl`}>
                  {phrase}
                </span>
                <IsotypeLogo
                  className="h-6 md:h-8 mx-8 md:mx-12 shrink-0"
                  oneColor={oneColor}
                  invert={invert}
                />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
